export default __webpack_public_path__ + "a2652099642d8cfc68966ecaa2317e4f.jpg";